export const SITE = {
  name: "Tbay Cleaning Services",
  legalName: "Tbay Cleaning Services Inc.",
  tagline: "Canada's premier commercial & residential cleaning network",
  phone: "807 697-5399",
  phoneIntl: "+1-807-697-5399",
  phoneHref: "tel:+18076975399",
  email: "admin@tbaycleaners.com",
  emailHref: "mailto:admin@tbaycleaners.com",
  hq: { province: "Ontario", code: "ON" },
  founded: 2019,
};
